module.exports = __webpack_public_path__ + "img/achievement-course8.c2a394e8.png";